import { render, staticRenderFns } from "./SentimentTimeSeries.vue?vue&type=template&id=bf5dbe0e&"
import script from "./SentimentTimeSeries.vue?vue&type=script&lang=js&"
export * from "./SentimentTimeSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports